module.exports = __webpack_public_path__ + "media/images/lp_v6_sp_sakiwari-0061affec63770d193ea4adec9ea26ef.webp";